<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2">mdi-dice-d20</v-icon>
        Dice Settings
      </v-card-title>
      <v-card-text v-if="character && character.characterData && character.characterData.offense && character.characterData.offense.diceSettings">
        <!-- Reroll Attacks -->
        <v-checkbox
          v-model="character.characterData.offense.diceSettings.rerollAttacks.enabled"
          label="Reroll Attacks"
          hide-details
          class="mb-2"
        ></v-checkbox>
        <div v-if="character.characterData.offense.diceSettings.rerollAttacks.enabled" class="ml-6 mb-4">
          <v-text-field
            v-model="character.characterData.offense.diceSettings.rerollAttacks.attacksToReroll"
            label="Attacks to Reroll"
            placeholder="attacks to reroll(a for all)"
            hide-details
            dense
            class="mb-3"
          ></v-text-field>
          <v-text-field
            v-model="character.characterData.offense.diceSettings.rerollAttacks.rerollTimes"
            label="Reroll Times"
            placeholder="negative = keep lowest, positive = keep highest"
            hide-details
            dense
          ></v-text-field>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Reroll Confirmations -->
        <v-checkbox
          v-model="character.characterData.offense.diceSettings.rerollConfirmations.enabled"
          label="Reroll Crit Confirmations"
          hide-details
          class="mb-2"
        ></v-checkbox>
        <div v-if="character.characterData.offense.diceSettings.rerollConfirmations.enabled" class="ml-6 mb-4">
          <v-text-field
            v-model="character.characterData.offense.diceSettings.rerollConfirmations.rerollTimes"
            label="Reroll Times"
            placeholder="enter number of rerolls"
            hide-details
            dense
          ></v-text-field>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Miss Chance -->
        <v-checkbox
          v-model="character.characterData.offense.diceSettings.missChance.enabled"
          label="Miss Chance"
          hide-details
          class="mb-2"
        ></v-checkbox>
        <div v-if="character.characterData.offense.diceSettings.missChance.enabled" class="ml-6 mb-4">
          <v-text-field
            v-model="character.characterData.offense.diceSettings.missChance.missChanceValue"
            label="Miss Chance Value"
            placeholder="enter miss chance percentage"
            hide-details
            dense
            class="mb-3"
          ></v-text-field>
          <v-checkbox
            v-model="character.characterData.offense.diceSettings.missChance.rerollMissChance.enabled"
            label="Reroll Miss Chance"
            hide-details
            class="mb-2"
          ></v-checkbox>
          <div v-if="character.characterData.offense.diceSettings.missChance.rerollMissChance.enabled" class="ml-6">
            <v-text-field
              v-model="character.characterData.offense.diceSettings.missChance.rerollMissChance.attacksToReroll"
              label="Attacks to Reroll"
              placeholder="attacks to reroll"
              hide-details
              dense
              class="mb-3"
            ></v-text-field>
            <v-text-field
              v-model="character.characterData.offense.diceSettings.missChance.rerollMissChance.rerollTimes"
              label="Reroll Times"
              placeholder="negative = keep lowest, positive = keep highest"
              hide-details
              dense
            ></v-text-field>
          </div>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Fortification -->
        <v-checkbox
          v-model="character.characterData.offense.diceSettings.fortification.enabled"
          label="Fortification"
          hide-details
          class="mb-2"
        ></v-checkbox>
        <div v-if="character.characterData.offense.diceSettings.fortification.enabled" class="ml-6 mb-4">
          <v-text-field
            v-model="character.characterData.offense.diceSettings.fortification.fortificationValue"
            label="Fortification Value"
            placeholder="enter fortification percentage"
            hide-details
            dense
            class="mb-3"
          ></v-text-field>
          <v-checkbox
            v-model="character.characterData.offense.diceSettings.fortification.rerollFortification.enabled"
            label="Reroll Fortification"
            hide-details
            class="mb-2"
          ></v-checkbox>
          <div v-if="character.characterData.offense.diceSettings.fortification.rerollFortification.enabled" class="ml-6">
            <v-text-field
              v-model="character.characterData.offense.diceSettings.fortification.rerollFortification.attacksToReroll"
              label="Attacks to Reroll"
              placeholder="attacks to reroll"
              hide-details
              dense
              class="mb-3"
            ></v-text-field>
            <v-text-field
              v-model="character.characterData.offense.diceSettings.fortification.rerollFortification.rerollTimes"
              label="Reroll Times"
              placeholder="negative = keep lowest, positive = keep highest"
              hide-details
              dense
            ></v-text-field>
          </div>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Ignore Precision -->
        <v-checkbox
          v-model="character.characterData.offense.diceSettings.ignorePrecision.enabled"
          label="Ignore Precision"
          hide-details
          class="mb-2"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AttackRollerSettingsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    character: {
      type: Object,
      required: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
